import type { IconNode } from '../types';

/**
 * @name gavel
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTQgMTMtOC4zODEgOC4zOGExIDEgMCAwIDEtMy4wMDEtM2w4LjM4NC04LjM4MSIgLz4KICA8cGF0aCBkPSJtMTYgMTYgNi02IiAvPgogIDxwYXRoIGQ9Im0yMS41IDEwLjUtOC04IiAvPgogIDxwYXRoIGQ9Im04IDggNi02IiAvPgogIDxwYXRoIGQ9Im04LjUgNy41IDggOCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/gavel
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const Gavel: IconNode = [
  ['path', { d: 'm14 13-8.381 8.38a1 1 0 0 1-3.001-3l8.384-8.381' }],
  ['path', { d: 'm16 16 6-6' }],
  ['path', { d: 'm21.5 10.5-8-8' }],
  ['path', { d: 'm8 8 6-6' }],
  ['path', { d: 'm8.5 7.5 8 8' }],
];

export default Gavel;
